import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=16ace67f&scoped=true"
import script from "./RoleTable.vue?vue&type=script&lang=ts"
export * from "./RoleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ace67f",
  null
  
)

export default component.exports